var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03BuenasPracticas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-preview",
    style: {
      maxWidth: "100%",
      maxHeight: 500
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 69.5,
    stroke: "#84bd00",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 112C50.694 112 33 94.306 33 72.5C33 50.694 50.694 33 72.5 33C94.306 33 112 50.694 112 72.5C112 94.306 94.306 112 72.5 112ZM72.5 41.5978C55.5536 41.5978 41.7224 55.429 41.7224 72.3754C41.7224 89.3218 55.5536 103.153 72.5 103.153C89.4464 103.153 103.278 89.3218 103.278 72.3754C103.278 55.429 89.4464 41.5978 72.5 41.5978Z",
    fill: "#84bd00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1677 87.9771L54.2245 80.2117C52.1062 79.2647 51.3586 77.276 52.6046 75.6661C53.8507 74.0562 56.4674 73.488 58.5857 74.435L69.1772 79.0753L85.3759 58.62C86.622 57.0101 89.2387 56.5366 91.357 57.4836C93.4753 58.4306 94.0983 60.4193 92.8523 62.0292L72.1677 87.9771Z",
    fill: "#84bd00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03BuenasPracticas);
export default __webpack_public_path__ + "static/media/icon03-buenas-practicas.5584e6dc81a92f04cce3ed262c4055c4.svg";
export { ForwardRef as ReactComponent };